package com.arenaproplay.admin.domain.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PaywallFunnelStepDto(
    @SerialName("key") val key: String,
    @SerialName("label") val label: String,
    @SerialName("userCount") val userCount: Long,
)

@Serializable
data class PaywallSourceRow(
    @SerialName("source") val source: String,
    @SerialName("shown") val shown: Long,
    @SerialName("tapped") val tapped: Long,
    @SerialName("purchased") val purchased: Long,
)

@Serializable
data class PaywallFunnelDto(
    @SerialName("steps") val steps: List<PaywallFunnelStepDto>,
    @SerialName("sources") val sources: List<PaywallSourceRow>,
)
